import {
  HttpInterceptorFn,
  HttpResponse,
  HttpErrorResponse,
} from "@angular/common/http";
import { throwError } from "rxjs";
import { map, catchError } from "rxjs/operators";

export const httpConfigInterceptor: HttpInterceptorFn = (request, next) => {
  return next(request).pipe(
    map((event) => {
      if (event instanceof HttpResponse) {
        console.log("event--->>>", event);
      }
      return event;
    }),
    catchError((error: HttpErrorResponse) => {
      return throwError(() => error);
    })
  );
};
